import { mapMimeTypeToGeneralType } from '../../../helpers'
import moment from 'moment'

const adminTable = (media) => {
  return {
    id: media.id,
    url: media.url,
    thumbnail: media.thumbnail,
    name: media.name,
    module_tags: media.modules,
    type: mapMimeTypeToGeneralType(media.mime_type),
    size: media.size,
    created: moment(media.created_at).unix()
  }
}

export default {
  set (state) {
    let set = []
    for (const view in state.views) {
      const data = state.views[view].ids.map((id) => state.views[view].index[id])
      set = set.concat(data)
    }

    return set
  },

  view (state) {
    return (view) => {
      return state.views[view].ids.map((id) => state.views[view].index[id]).map(adminTable)
    }
  },

  unsavedChanges (state) {
    const current = state.current
    const formFields = state.forms.update.fields
    let unsaved = false

    if (!current) {
      return unsaved
    }

    // replacing the media with a new upload
    if (formFields.file !== null || formFields.thumbnail !== null) {
      unsaved = true
    }

    if (formFields.name && current.name !== formFields.name) {
      unsaved = true
    }

    return unsaved
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/media/getters.js